<template>
  <v-card class="beez-card">
    <v-toolbar dense card>
      Select Honey User(s)
      <v-spacer></v-spacer>
<!--      <v-tooltip bottom>-->
<!--        <v-btn slot="activator" flat icon @click="clearAll">-->
<!--          <v-icon>clear_all</v-icon>-->
<!--        </v-btn>-->
<!--        <span>Clear All</span>-->
<!--      </v-tooltip>-->
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="closePopUp">
          <v-icon>close</v-icon>
        </v-btn>
        <span>Close</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <v-text-field
        color="secondary"
        outline
        label="Search"
        v-model="query"
        xs5
        clearable
        prepend-inner-icon="search"
      ></v-text-field>

      <v-list two-line>
        <v-progress-linear
          indeterminate
          :active="userSearchLoader"
        ></v-progress-linear>
        <v-list-tile
          v-for="(item, index) in assignableUsers"
          :key="index + 'user_item'"
          avatar
          @click="selectUser(item)"
        >
          <v-list-tile-avatar>
            <vue-letter-avatar
              :name="item.username"
              size="40"
              :rounded="true"
            />
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.username" />
            <v-list-tile-sub-title
              >{{ item.camundaUserName }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'UserPopUp',
  props: {
    value: Array,
    multiple: Boolean
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  data: () => {
    return {
      showDialog: true,
      query: '',
      assignableUsers: [],
      selectedUsers: [],
      userSearchLoader: false
    }
  },
  mounted() {
    this.selectedUsers = this.value
    this.fillUserList()
  },
  watch: {
    value() {
      this.selectedUsers = this.value
      this.fillUserList()
    },
    query() {
      this.fillUserList()
    }
  },
  methods: {
    closePopUp() {
      this.$emit('input', this.selectedUsers)
    },
    clearAll() {
      this.selectedUsers = []
      this.fillUserList()
      if (!this.multiple) {
        this.$emit('input', this.selectedUsers)
      }
    },
    fillUserList() {
      if (this.query && this.query.length >= 2) {
        this.userSearchLoader = true
        axios
          .get(
            '/api/v1/honeyUsers?page=1&size=20&search=' +
              this.query +
              '&sort=camundaUserName,asc'
          )
          .then(response => {
            if (response.data._embedded)
              this.assignableUsers = response.data._embedded.honeyUsers
            this.userSearchLoader = false
          })
          .catch(error => {
            console.log(error)
            this.userSearchLoader = false
          })
        this.userSearchLoader = false
      } else {
        this.assignableUsers = []
      }
      this.assignableUsers = this.assignableUsers.map(i => {
        if (this.selectedUsers) {
          i.select = !!this.selectedUsers.some(j => j.hexId === i.hexId)
        } else i.select = false
        return i
      })
    },
    selectUser(user) {
      if (!this.multiple) this.selectedUsers = []
      if (!this.selectedUsers.some(j => j.hexId === user.hexId))
        this.selectedUsers.push(user)
      else {
        let index = this.selectedUsers.findIndex(i => i.hexId === user.hexId)
        if (index !== -1) this.selectedUsers.splice(index, 1)
      }
      this.fillUserList()
      if (!this.multiple) {
        this.$emit('input', this.selectedUsers)
      }
    }
  }
}
</script>

<style scoped></style>
